var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalAssignPendiReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(-177 -637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assignment-svgrepo-com",
    transform: "translate(174 637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M11,3a1,1,0,0,1,2,0h2A3,3,0,1,0,9,3Z",
    transform: "translate(1)",
    fill: "#136ad0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M17.444,3h2.889C21.806,3,23,3.913,23,5.04V17.96C23,19.087,21.806,20,20.333,20H5.667C4.194,20,3,19.087,3,17.96V5.04C3,3.913,4.194,3,5.667,3H8.556V4.02a.806.806,0,0,0,.889.68h7.111a.806.806,0,0,0,.889-.68Zm-10,5.95a1.007,1.007,0,0,0-1.111.85,1.007,1.007,0,0,0,1.111.85H18.556a1.007,1.007,0,0,0,1.111-.85,1.007,1.007,0,0,0-1.111-.85Zm0,2.55a1.007,1.007,0,0,0-1.111.85,1.007,1.007,0,0,0,1.111.85H18.556a1.007,1.007,0,0,0,1.111-.85,1.007,1.007,0,0,0-1.111-.85Zm0,2.55a1.007,1.007,0,0,0-1.111.85,1.007,1.007,0,0,0,1.111.85h6.667a1.007,1.007,0,0,0,1.111-.85,1.007,1.007,0,0,0-1.111-.85Z",
    transform: "translate(0 0)",
    fill: "#136ad0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(83 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M265.1,227.69a2.287,2.287,0,1,0,2.287,2.287A2.287,2.287,0,0,0,265.1,227.69Zm0,3.659a1.372,1.372,0,1,1,1.372-1.372A1.374,1.374,0,0,1,265.1,231.348Z",
    transform: "translate(-155.159 415.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M704.816,692.08h-.686v1.091l.868.86.483-.487-.665-.659Z",
    transform: "translate(-594.536 -47.649)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalAssignPendiReview);
export default __webpack_public_path__ + "static/media/final-assign-pendi-review.56cdc69b03fbcb57d35163746aff6ac3.svg";
export { ForwardRef as ReactComponent };